import React from "react";
import { Helmet } from "react-helmet";
import { GlobalContext } from "./context/GlobalContext";

const SeoComp = () => {
  const { hitAxios } = React.useContext(GlobalContext);

  const [data, setData] = React.useState(null);

  React.useEffect(() => {
    (async () => {
      const res = await hitAxios({
        path: "/api/web/get_web_public",
        post: false,
        admin: false,
      });
      if (res.data.success && res.data.data) {
        setData(res.data.data);
      }
    })();
  }, []);

  if (!data) return null;

  return (
    <Helmet>
      {/* ── Basic ── */}
      {data.site_name && <title>{data.site_name}</title>}
      {data.meta_title && <meta name="title" content={data.meta_title} />}
      {data.meta_description && (
        <meta name="description" content={data.meta_description} />
      )}
      {data.meta_keywords && (
        <meta name="keywords" content={data.meta_keywords} />
      )}

      {/* ── Favicon ── */}
      <link rel="icon" href="/favicon.ico" type="image/x-icon" />

      {/* ── Open Graph ── */}
      {data.og_title && <meta property="og:title" content={data.og_title} />}
      {data.og_description && (
        <meta property="og:description" content={data.og_description} />
      )}
      {data.og_image && (
        <meta property="og:image" content={`/media/${data.og_image}`} />
      )}
      <meta property="og:type" content="website" />

      {/* ── Twitter Card ── */}
      <meta name="twitter:card" content="summary_large_image" />
      {data.og_title && <meta name="twitter:title" content={data.og_title} />}
      {data.og_description && (
        <meta name="twitter:description" content={data.og_description} />
      )}
      {data.og_image && (
        <meta name="twitter:image" content={`/media/${data.og_image}`} />
      )}

      {/* ── Google Analytics ── */}
      {data.google_analytics_id && (
        <script
          async
          src={`https://www.googletagmanager.com/gtag/js?id=${data.google_analytics_id}`}
        />
      )}
      {data.google_analytics_id && (
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${data.google_analytics_id}');
          `}
        </script>
      )}

      {/* ── Google Tag Manager ── */}
      {data.google_tag_manager_id && (
        <script>
          {`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${data.google_tag_manager_id}');
          `}
        </script>
      )}

      {/* ── Facebook Pixel ── */}
      {data.facebook_pixel_id && (
        <script>
          {`
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${data.facebook_pixel_id}');
            fbq('track', 'PageView');
          `}
        </script>
      )}
    </Helmet>
  );
};

export default SeoComp;
